import type { Activity } from '@/models'

export const useActivityStore = defineStore('activity.store', () => {
  const activityState = ref<undefined | Activity>(undefined)
  const errors = ref<string[]>([])

  const activity = computed(
    () => (!errors.value.length && activityState.value) || undefined,
  )

  const setActivity = (activity: Activity) => {
    if (typeof activity !== 'object' || !activity) {
      return errors.value.push(
        StringifyError({
          namespace: 'activity',
          error: 'not an activity',
          message: 'not an activity',
        }),
      )
    }

    errors.value = []
    activityState.value = activity
  }

  return {
    activityState,
    errors,
    activity,
    setActivity,
  }
})
